import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, ArrowUpRight } from "lucide-react";
import { Wordmark } from "@/components/Wordmark";

export function Footer() {
  const main = [
    { label: "Home", to: "/" },
    { label: "The Reconnection", to: "/the-reconnection" },
    { label: "Classes", to: "/classes" },
    { label: "Book", to: "/book" },
    { label: "Rooted in the Body", to: "/rooted-in-the-body" },
  ];
  const secondary = [
    { label: "About", to: "/about" },
    { label: "Contact", to: "/contact" },
    { label: "Terms & Conditions", to: "/terms" },
    { label: "Cancellation & Refunds", to: "/cancellation-refund" },
    { label: "Health & Fitness Disclaimer", to: "/health-disclaimer" },
    { label: "Acceptable Use", to: "/acceptable-use" },
    { label: "Cookie Policy", to: "/cookie-policy" },
    { label: "Privacy Policy", to: "/privacy-policy" },
  ];
  return (
    <footer data-testid="footer" className="relative overflow-hidden bg-ink-900 pt-28 pb-10 border-t border-white/5">
      <div className="absolute inset-0 mesh-top opacity-40" />
      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8">
          <div className="col-span-2 md:col-span-1">
            <Wordmark size="text-2xl" />
            <p className="text-mist text-sm mt-5 max-w-xs leading-relaxed">
              Movement designed for how humans are built to function.
            </p>
          </div>
          <div>
            <p className="label mb-5">Explore</p>
            <ul className="space-y-3">
              {main.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-ice/75 hover:text-cyan text-sm transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="label mb-5">More</p>
            <ul className="space-y-3">
              {secondary.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-ice/75 hover:text-cyan text-sm transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="label mb-5">Connect</p>
            <a href="https://instagram.com/i.amovement" target="_blank" rel="noreferrer"
               className="flex items-center gap-2 text-ice/75 hover:text-cyan text-sm mb-3 transition-colors">
              <Instagram size={16} /> @i.amovement <ArrowUpRight size={13} />
            </a>
            <a href="mailto:info@iamovement.co.uk"
               className="flex items-center gap-2 text-ice/75 hover:text-cyan text-sm transition-colors">
              <Mail size={16} /> info@iamovement.co.uk
            </a>
          </div>
        </div>

        <div className="mt-20 border-t border-white/5 pt-8 flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-mist text-xs">© <Link to="/admin" aria-label="Admin" data-testid="footer-admin-link" className="hover:text-ice transition-colors">2025</Link> I•AMovement. All rights reserved.</p>
          <Link to="/legal" className="text-mist text-xs hover:text-ice transition-colors">Legal & Copyright</Link>
        </div>
      </div>

      {/* Giant faded wordmark */}
      <div className="pointer-events-none select-none mt-12 -mb-6 overflow-hidden">
        <p className="font-display font-black text-center leading-none text-white/[0.035] whitespace-nowrap"
           style={{ fontSize: "clamp(4rem, 20vw, 20rem)" }}>
          I•AMovement
        </p>
      </div>
    </footer>
  );
}

export default Footer;
